import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import QueryTags from "api/types/QueryTags";
import PracticeTheme from "api/types/models/practice_theme";
import { UpdatePracticeThemeRequest } from "api/types/requests";

const practiceThemeEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  updatePracticeTheme: builder.mutation<
    PracticeTheme,
    UpdatePracticeThemeRequest
  >({
    query: ({ practiceId, body }) => ({
      url: `/practices/${practiceId}/theme`,
      method: "put",
      body,
    }),
    invalidatesTags: ["PracticeTheme"],
  }),
});

export default practiceThemeEndpoints;
